var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('kt-panel',[_c('kt-panel-body',[_c('kt-row',[_c('kt-col',{attrs:{"xs":"12","md":"6"}},[(_vm.status !== 'loading')?_c('ivr-info',{attrs:{"ivr":_vm.form_data}}):_vm._e()],1),_c('kt-col',{attrs:{"xs":"12","md":"6"}},[_c('gateway-statistics'),_c('ivr-setting'),_c('ivr-limits-settings')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }